export default __webpack_public_path__ + "static/media/ICON13.9318b15a.svg";